/**************************************************
 * Nombre:       Tarjeta_Mision
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {NEGRITA} from "../../Constantes";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Mision from "../Dialogos/Dialogo_Mision";

const Tarjeta_Mision = ({item}) => {
    const {Dialogo, abrir} = useDialogo({Componente: Dialogo_Mision})

    return (
        <>
            <Dialogo/>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                onClick={() => abrir(item)}
                sx={{
                    boxShadow: 2,
                    p: 2,
                    backgroundColor: 'white',
                    cursor: 'pointer',
                }}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                    <img src={item.img} style={{width: 64, height: 'auto'}}/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                    <Typography sx={{
                        fontSize: 26,
                        fontWeight: 600,
                        fontFamily: NEGRITA,
                        textAlign: 'center'
                    }}>{item.nombre}</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                    <Typography sx={{
                        fontSize: 18,
                        fontWeight: 600,
                        textAlign: 'center',
                        color: '#00000090',
                        lineHeight: 1.2,
                        textOverflow: "ellipsis",
                        display: '-webkit-box',
                        overflow: 'hidden',
                        WebkitBoxOrient: 'vertical',
                        WebkitLineClamp: 3
                    }}>{item.descripcion}</Typography>
                </Grid>

            </Grid>
        </>
    )

}
export default Tarjeta_Mision